/**
 * 汎用確認ダイアログ
 */
import React, {
} from "react";
import RippleButton from "../ui/rippleButton";

import "./ModalConfirm.css";

interface ModalConfirmProps {
  onApply: () => void;
  onCancel: () => void;
  title: string;
  message: string;
  applyButtonMessage: string;
  cancelButtonMessage: string;
}

const ModalConfirm: React.FC<ModalConfirmProps> = (props) => {

  return (
    <div className="modal-comfirm-container">
      <div className="modal-comfirm-title-item"><h1 className="primary">{props.title}</h1></div>
      <div className="modal-comfirm-message-item">{props.message}</div>
      <div className="modal-comfirm-apply-item">
        <RippleButton
          width={"200px"}
          heihgt={"62px"}
          borderRadius={"8px"}
          onClick={props.onApply}
          effectSize={160}
          className="bk-secondary"
        >
          <span className="children">{props.applyButtonMessage}</span>
        </RippleButton>
      </div>
      <div className="modal-comfirm-cancel-item">
        <RippleButton
          width={"200px"}
          heihgt={"62px"}
          borderRadius={"8px"}
          onClick={props.onCancel}
          effectSize={160}
          className="bk-secondary"
        >
          <span className="children">{props.cancelButtonMessage}</span>
        </RippleButton>
      </div>
    </div>
  );
};

export default ModalConfirm;
